import { render } from "./Sidebar.vue?vue&type=template&id=0419fca6&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=0419fca6&scoped=true&lang=css"
import "./Sidebar.vue?vue&type=style&index=1&id=0419fca6&lang=css"
script.render = render
script.__scopeId = "data-v-0419fca6"

export default script